import { Check } from "lucide-react";
import { PageHero, CTASection } from "../components/sections";
import { Reveal, Eyebrow, SectionHeader } from "../components/common";
import { IMAGES, VALUES, ENGAGEMENTS } from "../data/site";
import Seo from "../components/Seo";
import { SEO } from "../data/seo";

const method = [
  { n: "1", t: "Analyse personnalisée", d: "Visite de votre bien et compréhension de vos attentes spécifiques." },
  { n: "2", t: "Protocoles adaptés", d: "Création de check-lists et procédures sur-mesure pour votre logement." },
  { n: "3", t: "Exécution rigoureuse", d: "Chaque intervention suit un protocole précis avec contrôle qualité." },
  { n: "4", t: "Amélioration continue", d: "Écoute des retours et optimisation permanente de nos services." },
];

export default function APropos() {
  return (
    <div data-testid="apropos-page">
      <Seo {...SEO.apropos} />
      <PageHero
        eyebrow="À propos"
        title="Notre histoire, nos <em style='color:var(--gold-2)'>valeurs</em>"
        sub="Découvrez l'équipe passionnée derrière Groupe Cleanova - Sud et notre vision d'un service d'excellence."
        image={IMAGES.luxLiving}
      />

      <section className="section">
        <div className="container-x grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <Reveal><Eyebrow>Notre vision</Eyebrow></Reveal>
            <Reveal delay={80}>
              <h2 className="display-title mt-4 text-4xl md:text-5xl">
                Réinventer les standards du ménage et de la conciergerie
              </h2>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-5 leading-relaxed" style={{ color: "var(--muted)" }}>
                Groupe Cleanova - Sud est né d'un constat simple : les propriétaires
                de locations saisonnières méritent un partenaire à la hauteur de leurs exigences.
              </p>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-4 leading-relaxed" style={{ color: "var(--muted)" }}>
                Basés à Béziers, nous connaissons parfaitement le territoire et ses
                spécificités. Notre mission : vous libérer des contraintes opérationnelles
                pour que vous puissiez vous concentrer sur l'essentiel.
              </p>
            </Reveal>
            <Reveal delay={260}>
              <p className="mt-4 leading-relaxed" style={{ color: "var(--muted)" }}>
                Chaque prestation est réalisée avec le même souci du détail, que vous
                ayez un appartement ou plusieurs villas. L'excellence n'est pas une
                option, c'est notre standard.
              </p>
            </Reveal>
          </div>
          <Reveal delay={120}>
            <div className="relative">
              <img src={IMAGES.bedroom} alt="Logement" className="w-full object-cover" style={{ height: 500 }} />
              <div className="absolute -bottom-6 -right-6 px-8 py-6 text-center" style={{ background: "var(--gold)", color: "#fff" }}>
                <div className="font-display text-4xl">100%</div>
                <div className="text-xs tracking-widest uppercase mt-1">Clients satisfaits</div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section" style={{ background: "var(--cream)" }}>
        <div className="container-x">
          <SectionHeader eyebrow="Notre méthode" title="La rigueur au service de la qualité" sub="Notre approche repose sur des processus éprouvés et une attention constante aux détails." />
          <div className="grid md:grid-cols-4 gap-6 mt-14">
            {method.map((m, i) => (
              <Reveal key={m.n} delay={i * 100}>
                <div className="p-8 h-full" style={{ background: "#fff", border: "1px solid var(--line)" }}>
                  <div className="flex items-center justify-center font-display text-2xl" style={{ width: 48, height: 48, borderRadius: 999, background: "var(--ink)", color: "#fff" }}>
                    {m.n}
                  </div>
                  <h3 className="font-display text-2xl mt-5">{m.t}</h3>
                  <p className="mt-2 text-sm" style={{ color: "var(--muted)" }}>{m.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-x">
          <SectionHeader eyebrow="Nos valeurs" title="Ce qui nous définit" />
          <div className="grid md:grid-cols-4 gap-6 mt-14">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 90}>
                <div className="h-full pl-5" style={{ borderLeft: "2px solid var(--gold)" }}>
                  <h3 className="font-display text-3xl">{v.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--muted)" }}>{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ background: "var(--ink)" }}>
        <div className="container-x">
          <div className="max-w-2xl">
            <Reveal><Eyebrow light>Nos engagements</Eyebrow></Reveal>
            <Reveal delay={80}>
              <h2 className="display-title text-white mt-4 text-4xl md:text-5xl">Notre promesse envers vous</h2>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-4" style={{ color: "rgba(255,255,255,0.7)" }}>
                Des engagements concrets pour une collaboration en toute confiance.
              </p>
            </Reveal>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
            {ENGAGEMENTS.map((e, i) => (
              <Reveal key={e} delay={i * 70}>
                <div className="flex items-center gap-3 p-5 zone-card text-white">
                  <Check size={18} style={{ color: "var(--gold)" }} /> {e}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
